const BOUNDARY = 128;
export const getContrastYiq = (hex) => {
    const r = parseInt(hex.substring(1, 3), 16);
    const g = parseInt(hex.substring(3, 5), 16);
    const b = parseInt(hex.substring(5, 7), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= BOUNDARY ? 'dark' : 'light';
};
//# sourceMappingURL=getContrastYiq.js.map